import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { ToastContainer, toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";
import "../Usuario/UsuarioCad.scss";
import Select from "react-select";
import Swal from "sweetalert2";
import { color } from "@mui/system";
import { red } from "@mui/material/colors";


function UsuarioCad() {
  const [marcadores, setMarcadores] = useState([]);
  const [marcadoress, setMarcadoress] = useState([]);
  const [tipoPermissao, setTipoPermissao] = useState("");
  const [gruposPredefinidos, setGruposPredefinidos] = useState([]);
  const [gruposSelecionadas, setGruposSelecionadas] = useState([]);
  const [gruposPredefinidosCopy, setGruposPredefinidosCopy] = useState([]);
  const [gruposSelecionadasCopy, setGruposSelecionadasCopy] = useState([]);
  const [searchGrupos, setSearchGrupos] = useState("");
  const navigate = useNavigate();
  const [grupos, setGrupos] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedOptions, setSelectedOptions] = useState(null);
  const [selectedOptions1, setSelectedOptions1] = useState(null);
  const [values, setValues] = useState({});
  const [emailError, setEmailError] = useState("");
  const [userError, setUserError] = useState("");
  const [senha, setSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [senhaError, setSenhaError] = useState("");
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [mostrarConfirmar, setMostrarConfirmar] = useState(false);
  const [errors, setErrors] = useState({});
  const [veiculos, setVeiculos] = useState([]);
  const [veiculosSelecionados, setVeiculosSelecionados] = useState([]);
  const [selecionarTodos, setSelecionarTodos] = useState(false);
  const [telefoneVerificado, setTelefoneVerificado] = useState(false);
  const [enviandoCodigo, setEnviandoCodigo] = useState(false);
  const [usarTelefone, setUsarTelefone] = useState(false);
  const [telefoneExistente, setTelefoneExistente] = useState(false);
  const [verificandoTelefone, setVerificandoTelefone] = useState(false);
  const [errosCampos, setErrosCampos] = useState({});
  const [emailVerificado, setEmailVerificado] = useState(false);
  const [emailValidando, setEmailValidando] = useState(false);
  const [codigoEmail, setCodigoEmail] = useState("");
  const [codigoEnviado, setCodigoEnviado] = useState(false);
  const [codigoEmailErro, setCodigoEmailErro] = useState("");
  const [emailCodigo, setEmailCodigo] = useState("");
  const [email, setEmail] = useState("");
  const [emailDisponivel, setEmailDisponivel] = useState(false);
  const [verificandoEmail, setVerificandoEmail] = useState(false);




  const veiculosDisponiveis = veiculos.filter(
    v => !veiculosSelecionados.some(sel => sel.placa === v.placa)
  );



  //============================
  //MOVER VEICULOS SELECIONADOS 
  //============================
  const moverParaSelecionados = (veiculo) => {
    setVeiculosSelecionados(prev => {
      if (prev.some(v => v.placa === veiculo.placa)) return prev;
      return [...prev, veiculo];
    });
  };

  //========================
  //REMOVER DE SELECIONADOS
  //========================
  const moverParaDisponiveis = (veiculo) => {
    setVeiculosSelecionados(prev =>
      prev.filter(v => v.placa !== veiculo.placa)
    );
  };
































  useEffect(() => {
    if (confirmarSenha && senha !== confirmarSenha) {
      setSenhaError("As senhas não coincidem");
    } else {
      setSenhaError("");
    }
  }, [senha, confirmarSenha]);

  const verificarUser = async (user) => {
    if (!user) return;

    try {
      const response = await api.post("/usuarios/verificar", { user });
      setUserError(""); // usuário disponível
    } catch (error) {
      if (error.response && error.response.data.campo === "user") {
        setUserError(error.response.data.mensagem); // Usuário já está em uso
      }
    }
  };

  const verificarEmail = async (emailInformado) => {
    const email = emailInformado.trim();

    // Campo vazio = e-mail opcional
    if (!email) {
      setEmailError("");
      setEmailDisponivel(false);
      setVerificandoEmail(false);
      return;
    }

    // Ainda não parece um e-mail válido
    const emailValido = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    if (!emailValido) {
      setEmailError("");
      setEmailDisponivel(false);
      return;
    }

    try {
      setVerificandoEmail(true);
      setEmailError("");
      setEmailDisponivel(false);

      const response = await api.post("/usuarios/verificar", {
        email,
      });

      // E-mail disponível
      setEmailError("");
      setEmailDisponivel(true);

    } catch (error) {

      if (
        error.response &&
        error.response.data.campo === "email"
      ) {
        setEmailError(
          error.response.data.mensagem
        );

        setEmailDisponivel(false);
        return;
      }

      setEmailError("Não foi possível verificar o e-mail.");
      setEmailDisponivel(false);

    } finally {
      setVerificandoEmail(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      verificarEmail(email);
    }, 600);

    return () => clearTimeout(timer);
  }, [email]);














  const optionList = marcadores.map((marcador, index) => ({ value: marcador.placa, label: marcador.placa }));
  const optionList1 = marcadoress.map((marcador, index) => ({ value: marcador.nome, label: marcador.nome }));



  useEffect(() => {
    async function fetchData() {
      const { data } = await api.get("/grupos1", {
        headers: {
          typo: localStorage.getItem("id"),
          inova: localStorage.getItem("inova"),
        },
      });
      setMarcadoress(data);
    }
    fetchData();
  }, []);


  //=====================
  // VALIDAÇÃO DE DADOS 
  //=====================

  const validarCampos = () => {
    let novosErros = {};

    if (!values.nome?.trim()) {
      novosErros.nome = "Nome é obrigatório";
    }

    if (!values.user?.trim()) {
      novosErros.user = "Usuário é obrigatório";
    }

    if (!values.email?.trim()) {
      novosErros.email = "E-mail é obrigatório";
    }

    if (!senha?.trim()) {
      novosErros.senha = "Senha é obrigatória";
    }

    if (!confirmarSenha?.trim()) {
      novosErros.confirmarSenha = "Confirme a senha";


    }

    if (!values.tipo) {
      novosErros.tipo = "Tipo de permissão é obrigatório";
    }

    if (senha && confirmarSenha && senha !== confirmarSenha) {
      novosErros.confirmarSenha = "As senhas não coincidem";
    }

    setErrors(novosErros);

    return Object.keys(novosErros).length === 0;
  };


  //================
  // ENVIAR DADOS 
  //================

  const handleSubmit = async (e) => {
    console.log("🔥 HANDLE SUBMIT FOI CHAMADO");

    console.log("usarTelefone:", usarTelefone);
    console.log("telefoneVerificado:", telefoneVerificado);
    console.log("telefoneExistente:", telefoneExistente);
    console.log("verificandoTelefone:", verificandoTelefone);
    console.log("values:", values);

    e.preventDefault();

    // =========================================================
    // NORMALIZAÇÃO INICIAL
    // =========================================================

    const email = values.email?.trim().toLowerCase() || "";

    // =========================================================
    // VALIDAÇÃO DOS CAMPOS OBRIGATÓRIOS
    // =========================================================

    const camposObrigatorios = [
      {
        campo: "nome",
        valor: values.nome,
        mensagem: "Informe o nome completo.",
      },
      {
        campo: "user",
        valor: values.user,
        mensagem: "Informe o nome de usuário.",
      },
      {
        campo: "senha",
        valor: senha,
        mensagem: "Informe uma senha.",
      },
      {
        campo: "confirmarSenha",
        valor: confirmarSenha,
        mensagem: "Confirme a senha.",
      },
    ];

    const camposComErro = camposObrigatorios.filter(
      (item) => !item.valor || !String(item.valor).trim()
    );

    // =========================================================
    // LIMPA ERROS ANTERIORES
    // =========================================================

    setErrosCampos({});

    if (camposComErro.length > 0) {
      const novosErros = {};

      camposComErro.forEach((item) => {
        novosErros[item.campo] = item.mensagem;
      });

      setErrosCampos(novosErros);

      setTimeout(() => {
        const elemento = document.querySelector(
          `[name="${camposComErro[0].campo}"]`
        );

        if (elemento) {
          elemento.focus();
        }
      }, 100);

      return;
    }

    // =========================================================
    // VALIDAÇÃO DE ERROS JÁ EXISTENTES
    // =========================================================

    if (emailError || userError) {
      toast.error("Corrija os campos destacados antes de continuar.");

      setErrosCampos((prev) => ({
        ...prev,

        ...(emailError
          ? {
            email: "Este e-mail já está cadastrado.",
          }
          : {}),

        ...(userError
          ? {
            user: "Este usuário já está cadastrado.",
          }
          : {}),
      }));

      setTimeout(() => {
        const primeiroCampo = emailError ? "email" : "user";

        const elemento = document.querySelector(
          `[name="${primeiroCampo}"]`
        );

        if (elemento) {
          elemento.focus();
        }
      }, 100);

      return;
    }

    // =========================================================
    // VALIDAÇÃO DO E-MAIL
    // =========================================================

    if (email && !emailVerificado) {
      toast.error("Valide o e-mail antes de continuar.");

      setTimeout(() => {
        const elemento = document.querySelector('[name="email"]');

        if (elemento) {
          elemento.focus();
        }
      }, 100);

      return;
    }

    // =========================================================
    // VALIDAÇÃO DO TELEFONE
    // =========================================================

    if (usarTelefone) {
      if (telefoneExistente) {
        toast.error("Este número de telefone já está cadastrado.");
        return;
      }

      if (!telefoneVerificado) {
        toast.error("Confirme o número de telefone antes de continuar.");
        return;
      }
    }

    // =========================================================
    // NORMALIZAÇÃO
    // =========================================================

    const nome = values.nome?.trim();
    const user = values.user?.trim();

    const listaVeiculos = veiculosSelecionados.map(
      (v) => v.placa
    );

    const listaGrupos = gruposSelecionadas.map(
      (g) => g.nome
    );

    // =========================================================
    // CONFIRMAÇÃO
    // =========================================================

    const result = await Swal.fire({
      width: "600px",
      padding: "0",
      background: "#0b1220",
      color: "#f8fafc",

      html: `
    <style>

      .confirm-usuario-modal {
        width: 100%;
        text-align: left;
        font-family: inherit;
      }

      /* ==============================
         HEADER
      ============================== */

      .confirm-usuario-header {
        display: flex;
        align-items: center;
        gap: 13px;
        padding: 22px 24px 18px;
        border-bottom: 1px solid rgba(148,163,184,.08);
      }

      .confirm-usuario-icon {
        width: 42px;
        height: 42px;
        min-width: 42px;
        display: flex;
        align-items: center;
        justify-content: center;

        border-radius: 11px;

        background: rgba(14,165,233,.09);
        border: 1px solid rgba(14,165,233,.16);

        color: #38bdf8;
      }

      .confirm-usuario-header h2 {
        margin: 0;
        font-size: 17px;
        line-height: 1.2;
        font-weight: 700;
        color: #f8fafc;
      }

      .confirm-usuario-header p {
        margin: 4px 0 0;
        font-size: 12px;
        color: #64748b;
      }


      /* ==============================
         CONTEÚDO
      ============================== */

      .confirm-usuario-content {
        padding: 20px 24px 4px;
      }


      /* ==============================
         INFORMAÇÕES
      ============================== */

      .confirm-usuario-card {
        background: #101827;
        border: 1px solid rgba(148,163,184,.09);
        border-radius: 12px;
        overflow: hidden;
      }

      .confirm-usuario-card-title {
        padding: 11px 14px;

        font-size: 10px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: .8px;

        color: #64748b;

        background: rgba(255,255,255,.015);

        border-bottom: 1px solid rgba(148,163,184,.07);
      }

      .confirm-usuario-row {
        display: grid;
        grid-template-columns: 90px 1fr;
        align-items: center;

        min-height: 43px;

        padding: 0 14px;

        border-bottom: 1px solid rgba(148,163,184,.055);
      }

      .confirm-usuario-row:last-child {
        border-bottom: none;
      }

      .confirm-usuario-label {
        font-size: 12px;
        color: #64748b;
      }

      .nao-informado{
        font-size: 12px;

        border-radius: 4px;

        padding-left: 2px;

        display: inline-flex !important;
        width: fit-content !important;
        max-width: fit-content !important;
        margin-left:63.1% !important;
        position: absolute;


        align-items: center;
        justify-content: center;

        padding: 4px 10px;

        font-size: 12px;
        font-weight: 500;
        line-height: 1;

        color: #e03030;
        background-color:  #cf30301d;

        border: 1px solid #cf30301d;
        border-radius: 5px;

        white-space: nowrap;


        }
        
    .permissao {
      display: inline-flex !important;
      width: fit-content !important;
      max-width: fit-content !important;
       margin-left:63.1% !important;
        position: absolute;


      align-items: center;
      justify-content: center;

      padding: 4px 10px;

      font-size: 12px;
      font-weight: 500;
      line-height: 1;

      color: #3dcb36;
      background: rgba(61, 203, 54, 0.10);

      border: 1px solid rgba(61, 203, 54, 0.18);
      border-radius: 5px;

      white-space: nowrap;
    }

        .confirm-usuario-value {
        min-width: 0;

        display: flex;
        justify-content: flex-end;
        align-items: center;

        font-size: 13px;
        font-weight: 600;

        color: #e2e8f0;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }


      /* ==============================
         RESUMO
      ============================== */

      .confirm-usuario-stats {
        display: grid;
        grid-template-columns: 1fr 1fr;

        gap: 10px;

        margin-top: 10px;
      }

      .confirm-usuario-stat {
        display: flex;
        align-items: center;
        gap: 11px;

        padding: 13px 14px;

        background: #101827;

        border: 1px solid rgba(148,163,184,.09);
        border-radius: 12px;
      }

      .confirm-usuario-stat-icon {
        width: 32px;
        height: 32px;
        min-width: 32px;

        display: flex;
        align-items: center;
        justify-content: center;

        border-radius: 9px;

        background: rgba(14,165,233,.08);

        color: #38bdf8;
      }

      .confirm-usuario-stat-label {
        font-size: 10px;

        text-transform: uppercase;
        letter-spacing: .7px;

        color: #64748b;
      }

      .confirm-usuario-stat-value {
        margin-top: 2px;

        font-size: 17px;
        line-height: 1;

        font-weight: 700;

        color: #f8fafc;
      }


      /* ==============================
         AVISO
      ============================== */

      .confirm-usuario-info {
        display: flex;
        align-items: center;
        gap: 9px;

        margin-top: 10px;

        padding: 10px 12px;

        border-radius: 9px;

        background: rgba(14,165,233,.045);
        border: 1px solid rgba(14,165,233,.10);

        color: #64748b;

        font-size: 11px;
        line-height: 1.4;
      }

      .confirm-usuario-info svg {
        flex-shrink: 0;
        color: #38bdf8;
      }


      /* ==============================
         BOTÕES
      ============================== */

      .confirm-usuario-actions {
        display: flex;

        justify-content: flex-end;

        gap: 8px;

        padding: 18px 24px 20px;
      }

      .confirm-usuario-cancel,
      .confirm-usuario-confirm {
        height: 38px;

        padding: 0 17px;

        border-radius: 9px !important;

        font-size: 12px !important;
        font-weight: 600 !important;

        transition: .18s ease !important;
      }

      .confirm-usuario-cancel {
        background: #182235 !important;

        color: #cbd5e1 !important;

        border: 1px solid rgba(148,163,184,.10) !important;
      }

      .confirm-usuario-cancel:hover {
        background: #202d43 !important;
      }

      .confirm-usuario-confirm {
        background: #147fc1 !important;

        color: #fff !important;

        border: none !important;

        box-shadow: 0 5px 16px rgba(20,127,193,.18) !important;
      }

      .confirm-usuario-confirm:hover {
        background: #168bd1 !important;

        transform: translateY(-1px);
      }


      /* ==============================
         RESPONSIVO
      ============================== */

      @media (max-width: 600px) {

        .confirm-usuario-header {
          padding: 18px;
        }

        .confirm-usuario-content {
          padding: 16px 18px 4px;
        }

        .confirm-usuario-actions {
          padding: 16px 18px 18px;
        }

        .confirm-usuario-row {
          grid-template-columns: 75px 1fr;
        }

        .confirm-usuario-value {
          font-size: 12px;
        }

      }

    </style>


    <div class="confirm-usuario-modal">

      <!-- HEADER -->

      <div class="confirm-usuario-header">

        <div class="confirm-usuario-icon">

          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>

        </div>

        <div>

          <h2>Confirmar cadastro</h2>

          <p>
            Confira os dados antes de continuar
          </p>

        </div>

      </div>


      <!-- CONTEÚDO -->

      <div class="confirm-usuario-content">

        <!-- DADOS -->

        <div class="confirm-usuario-card">

          <div class="confirm-usuario-card-title">
            Informações do usuário
          </div>


          <div class="confirm-usuario-row">

            <span class="confirm-usuario-label">
              Nome
            </span>

            <span class="confirm-usuario-value">
              ${nome || "-"}
            </span>

          </div>


          <div class="confirm-usuario-row">

            <span class="confirm-usuario-label">
              Usuário
            </span>

            <span class="confirm-usuario-value">
              ${user || "-"}
            </span>

          </div>


          <div class="confirm-usuario-row">

            <span class="confirm-usuario-label">
              E-mail
            </span>

           <span class="confirm-usuario-value">
            ${email || `<span class="nao-informado">Não foi cadastrado</span>`}
          </span>

          </div>

          <div class="confirm-usuario-row">

            <span class="confirm-usuario-label">
              Telefone
            </span>

             <span class="confirm-usuario-value">
            ${telefoneExistente || `<span class="nao-informado">Não foi cadastrado</span>`}
          </span>

          </div>


          <div class="confirm-usuario-row">

            <span class="confirm-usuario-label">
              Permissão
            </span>

           <span class="permissao">
           ${tipoPermissao === "a" ? "Administrador" : "Usuário"}
            </span>
        
            </span>

          </div>

        </div>


        <!-- RESUMO -->

        <div class="confirm-usuario-stats">

          <!-- VEÍCULOS -->

          <div class="confirm-usuario-stat">

            <div class="confirm-usuario-stat-icon">

              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect
                  x="3"
                  y="5"
                  width="18"
                  height="14"
                  rx="2"
                />

                <path d="M7 9h10"/>
                <path d="M7 13h6"/>
              </svg>

            </div>

            <div>

              <div class="confirm-usuario-stat-label">
                Veículos
              </div>

              <div class="confirm-usuario-stat-value">
                ${listaVeiculos.length}
              </div>

            </div>

          </div>


          <!-- GRUPOS -->

          <div class="confirm-usuario-stat">

            <div class="confirm-usuario-stat-icon">

              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M4 7h16"/>
                <path d="M4 12h16"/>
                <path d="M4 17h16"/>
              </svg>

            </div>

            <div>

              <div class="confirm-usuario-stat-label">
                Grupos
              </div>

              <div class="confirm-usuario-stat-value">
                ${listaGrupos.length}
              </div>

            </div>

          </div>

        </div>


        <!-- AVISO -->

        <div class="confirm-usuario-info">

          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle
              cx="12"
              cy="12"
              r="9"
            />

            <path d="M12 11v5"/>
            <path d="M12 8h.01"/>
          </svg>

          <span>
            Após confirmar, o usuário será cadastrado no sistema.
          </span>

        </div>

      </div>

    </div>
  `,

      showCancelButton: true,

      confirmButtonText: "Confirmar cadastro",
      cancelButtonText: "Cancelar",

      reverseButtons: true,

      focusCancel: true,

      customClass: {
        popup: "swal-usuario-confirmacao",

        actions: "confirm-usuario-actions",

        confirmButton: "confirm-usuario-confirm",

        cancelButton: "confirm-usuario-cancel",
      },
    });

    // =========================================================
    // RESULTADO DA CONFIRMAÇÃO
    // =========================================================

    console.log("➡️ SWEETALERT TERMINOU");
    console.log("➡️ result.isConfirmed:", result.isConfirmed);

    if (!result.isConfirmed) {
      console.log("❌ Cadastro cancelado pelo usuário");
      return;
    }

    // =========================================================
    // CADASTRO
    // =========================================================

    try {
      const veiculos = listaVeiculos
        .map((placa) => `'${placa}'`)
        .join(",");

      const grupos = gruposSelecionadas
        .map((grupo) => grupo.id)
        .join(",");

      const dadosCadastro = {
        ...values,

        nome,
        user,
        email,
        senha,

        veiculos,
        grupos,


        cliente: localStorage.getItem("id"),
        criado_por: localStorage.getItem("clientID"),
      };

      console.log("🚀 VAI FAZER POST /usuarios");
      console.log("📦 DADOS ENVIADOS:", dadosCadastro);

      const respostaCadastro = await api.post(
        "/usuarios",
        dadosCadastro
      );

      console.log(
        "✅ RESPOSTA DO BACKEND:",
        respostaCadastro.data
      );

      const usuarioCriado = respostaCadastro.data;

      // =========================================================
      // SUCESSO
      // =========================================================

      await Swal.fire({
        width: 390,

        background: "#0f172a",
        color: "#fff",

        title: `
        <div style="
          font-size:19px;
          font-weight:700;
          color:#f8fafc;
        ">
          Usuário cadastrado
        </div>
      `,

        html: `
        <div style="
          margin-top:5px;
          color:#94a3b8;
          font-size:12px;
        ">
          O cadastro foi realizado com sucesso.
        </div>
      `,

        icon: "success",

        timer: 1600,
        showConfirmButton: false,
      });

      navigate(-1);

    } catch (error) {

      console.error("❌ ERRO AO CADASTRAR USUÁRIO:", error);

      console.error(
        "❌ STATUS:",
        error?.response?.status
      );

      console.error(
        "❌ RESPOSTA:",
        error?.response?.data
      );

      const mensagem =
        error?.response?.data?.erro ||
        error?.response?.data?.mensagem ||
        "";

      // =========================================================
      // E-MAIL DUPLICADO
      // =========================================================

      if (
        mensagem.toLowerCase().includes("usuario_email") ||
        (
          mensagem.toLowerCase().includes("email") &&
          mensagem.toLowerCase().includes("already exists")
        )
      ) {

        setErrosCampos((prev) => ({
          ...prev,
          email: "Este e-mail já está cadastrado.",
        }));

        toast.error("Este e-mail já está cadastrado.");

        setTimeout(() => {

          const elemento = document.querySelector(
            '[name="email"]'
          );

          if (elemento) {
            elemento.focus();
          }

        }, 100);

        return;
      }

      // =========================================================
      // ERRO GENÉRICO
      // =========================================================

      Swal.fire({
        width: 400,

        background: "#0f172a",
        color: "#fff",

        title: "Erro ao cadastrar usuário",

        html: `
        <div style="
          color:#94a3b8;
          font-size:12px;
          margin-top:5px;
        ">
          Não foi possível concluir o cadastro.
        </div>
      `,

        icon: "error",

        confirmButtonText: "Entendi",
        confirmButtonColor: "#147fc1",
      });
    }
  };

  function handleSelect(e) {
    setSelectedOptions(e);

    ///* console.log(e);
  }




  function handleSelect1(e) {
    setSelectedOptions1(e);
    ///* console.log(e);
  }
  const handleChange = (event) => {
    const { name, value } = event.target;

    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));

    if (name === "tipo") {
      setTipoPermissao(value);
    }

    if (name === "email") {
      verificarEmail(value);
    }

    if (name === "user") {
      verificarUser(value);
    }
  };

  // const handleSelecionadas = (valor1) => {
  //  const placa = veiculosSelecionados
  //   .map((placa) => `'${placa}'`)
  //   .join(",");




  // const handlePredefinidas = (valor2) => {
  //   const update4 = [...notificacoesPredefinidas, valor2];
  //   setNotificacoesPredefinidas(update4);
  //   setNotificacoesPredefinidasCopy(update4);
  //   const update3 = [...notificacoesSelecionadas];
  //   update3.splice(notificacoesSelecionadas.indexOf(valor2), 1);
  //   setNotificacoesSelecionadas(update3);
  //   setNotificacoesSelecionadasCopy(update3);
  // };



  //=====================
  //BUSCAR EQUIPAMENTOS
  //=====================
  useEffect(() => {
    async function fetchEquipamentos() {
      try {
        const { data } = await api.get("/equipamentos", {
          headers: {
            typo: localStorage.getItem("id"),
            inova: localStorage.getItem("inova"),
          },
        });

        const veiculosUnicos = Array.from(
          new Map(data.map(v => [v.placa, v])).values()
        );


        setVeiculos(veiculosUnicos);



      } catch (error) {
        toast.error("Erro ao carregar veículos");
      }
    }

    fetchEquipamentos();
  }, []);


  useEffect(() => {
    if (veiculosSelecionados.length === veiculos.length && veiculos.length > 0) {
      setSelecionarTodos(true);
    } else {
      setSelecionarTodos(false);
    }
  }, [veiculosSelecionados, veiculos]);


  //============================
  // SELECIONAR TODOS VEICULOS
  //=============================
  const handleAll = (checked) => {
    setSelecionarTodos(checked);

    if (checked) {
      setVeiculosSelecionados([...veiculos]);
    } else {
      setVeiculosSelecionados([]);
    }
  };





  // const filterPlaca = notificacoesPredefinidas.filter((placa, index) => placa.includes(search));

  //==========
  //FILTRA DADOS
  //============
  const filterPlaca = veiculosDisponiveis.filter((v) =>
    v.placa.toLowerCase().includes(search.toLowerCase()) ||
    v.nome.toLowerCase().includes(search.toLowerCase())
  );



  //====================
  //SELECÇÃO DE GRUPOS
  //====================
  const handleSelecionadasGrupos = (grupo) => {
    const update = [...gruposSelecionadas, grupo];
    setGruposSelecionadas(update);
    setGruposSelecionadasCopy(update);

    const update2 = gruposPredefinidos.filter((g) => g.id !== grupo.id);
    setGruposPredefinidos(update2);
    setGruposPredefinidosCopy(update2);
  };




  const handlePredefinidasGrupos = (grupo) => {
    const update = [...gruposPredefinidos, grupo];
    setGruposPredefinidos(update);
    setGruposPredefinidosCopy(update);

    const update2 = gruposSelecionadas.filter((g) => g.id !== grupo.id);
    setGruposSelecionadas(update2);
    setGruposSelecionadasCopy(update2);
  };

  useEffect(() => {
    async function fetchGrupos() {
      const { data } = await api.get("/grupos1", {
        headers: {
          typo: localStorage.getItem("id"),
          inova: localStorage.getItem("inova"),
        },
      });

      setMarcadoress(data);

      setGruposPredefinidos(data);
    }
    fetchGrupos();
  }, []);

  //===========================
  //SELECIONAR TODOS OS GRUPOS
  //===========================
  const handleAllGrupos = (value) => {
    if (value) {
      if (gruposSelecionadas.length === 0) {
        setGruposPredefinidosCopy([...gruposPredefinidos]);
      }
      setGruposSelecionadas([...gruposSelecionadas, ...gruposPredefinidos]);
      setGruposPredefinidos([]);
    } else {
      setGruposSelecionadas([...gruposSelecionadasCopy]);
      setGruposPredefinidos([...gruposPredefinidosCopy]);
    }
  };


  const filterGrupos = gruposPredefinidos.filter((grupo) => grupo.nome.toLowerCase().includes(searchGrupos.toLowerCase()));

  //========================
  //OPÇÕES  TIPO DE USUARIO
  //========================
  const opcoesTipo = [

    { value: "a", label: "Administrador" },
    { value: "u", label: "Usuário" },
  ];
  const handleTipoChange = (selectedOption) => {
    setTipoPermissao(selectedOption?.value);

    setValues((prev) => ({
      ...prev,
      tipo: selectedOption?.value || "",
    }));
  };



  const confirmarTelefone = async () => {
    const telefone = (values.telefone || "").replace(/\D/g, "");

    if (!telefone) {
      return true;
    }

    if (telefone.length !== 11) {
      Swal.fire({
        icon: "warning",
        title: "Número inválido",
        text: "Informe o DDD e o número completo. Exemplo: (11) 99999-9999.",
        background: "#0b1722",
        color: "#e8f1f7",
        confirmButtonColor: "#1686bd",
      });

      return false;
    }



    try {
      setEnviandoCodigo(true);

      // ==========================================
      // ENVIA SMS
      // ==========================================

      let data;

      try {
        const respostaSms = await api.post(
          "/usuario/enviar-codigo-sms",
          {
            telefone,
          }
        );

        data = respostaSms.data;

      } catch (errorSms) {
        console.error(
          "Erro ao enviar SMS:",
          errorSms
        );

        const status = errorSms.response?.status;

        const codigoErro =
          errorSms.response?.data?.codigo;

        const mensagemErro =
          errorSms.response?.data?.mensagem ||
          errorSms.response?.data?.message ||
          errorSms.message ||
          "Não foi possível enviar o código.";

        // ==========================================
        // LIMITE DIÁRIO DE SMS
        // ==========================================

        if (
          status === 429 ||
          codigoErro === "SMS_DAILY_LIMIT"
        ) {
          setEnviandoCodigo(false);

          await Swal.fire({
            width: "500px",
            padding: "0",
            background: "#0b1722",
            color: "#e8f1f7",

            html: `
          <div style="
            padding:26px 28px;
            text-align:left;
          ">

            <div style="
              display:flex;
              align-items:center;
              gap:12px;
              margin-bottom:16px;
            ">

              <div style="
                width:40px;
                height:40px;
                border-radius:10px;
                display:flex;
                align-items:center;
                justify-content:center;
                color:#fbbf24;
                background:rgba(245,158,11,.07);
                border:1px solid rgba(245,158,11,.22);
              ">
                <i class="bi bi-phone"></i>
              </div>

              <div>
                <div style="
                  font-size:17px;
                  font-weight:700;
                  color:#f8fafc;
                ">
                  Não foi possível enviar o código
                </div>

                <div style="
                  margin-top:3px;
                  font-size:12px;
                  color:#64748b;
                ">
                  O envio de SMS está temporariamente indisponível.
                </div>
              </div>

            </div>

            <div style="
              padding:12px 14px;
              border-radius:10px;
              background:#101d2a;
              border:1px solid rgba(148,163,184,.10);
              color:#94a3b8;
              font-size:12px;
              line-height:1.5;
            ">
              O limite diário de envio de SMS foi atingido.
              <br>
              Tente novamente mais tarde.
            </div>

          </div>
        `,

            confirmButtonText: "Entendi",

            confirmButtonColor: "#147fc1",

            customClass: {
              popup: "swal-usuario-sms",
              confirmButton: "swal-usuario-sms-confirm",
            },
          });

          return false;
        }

        // ==========================================
        // OUTROS ERROS NO ENVIO DO SMS
        // ==========================================

        setEnviandoCodigo(false);

        await Swal.fire({
          width: "500px",
          padding: "0",
          background: "#0b1722",
          color: "#e8f1f7",

          html: `
        <div style="
          padding:26px 28px;
          text-align:left;
        ">

          <div style="
            display:flex;
            align-items:center;
            gap:12px;
            margin-bottom:16px;
          ">

            <div style="
              width:40px;
              height:40px;
              border-radius:10px;
              display:flex;
              align-items:center;
              justify-content:center;
              color:#f87171;
              background:rgba(239,68,68,.07);
              border:1px solid rgba(239,68,68,.22);
            ">
              <i class="bi bi-exclamation-triangle"></i>
            </div>

            <div>
              <div style="
                font-size:17px;
                font-weight:700;
                color:#f8fafc;
              ">
                Não foi possível enviar o código
              </div>

              <div style="
                margin-top:3px;
                font-size:12px;
                color:#64748b;
              ">
                Ocorreu um problema ao enviar o SMS.
              </div>
            </div>

          </div>

          <div style="
            padding:12px 14px;
            border-radius:10px;
            background:#101d2a;
            border:1px solid rgba(148,163,184,.10);
            color:#94a3b8;
            font-size:12px;
            line-height:1.5;
          ">
            ${mensagemErro}
          </div>

        </div>
      `,

          confirmButtonText: "Entendi",

          confirmButtonColor: "#147fc1",

          customClass: {
            popup: "swal-usuario-sms",
            confirmButton: "swal-usuario-sms-confirm",
          },
        });

        return false;
      }

      // ==========================================
      // VALIDA RESPOSTA DO ENVIO
      // ==========================================

      if (!data?.sucesso) {
        setEnviandoCodigo(false);

        await Swal.fire({
          width: "500px",
          padding: "0",
          background: "#0b1722",
          color: "#e8f1f7",

          icon: "warning",

          title: "Não foi possível enviar o código",

          text:
            data?.mensagem ||
            "Não foi possível enviar o código.",

          confirmButtonText: "Entendi",

          confirmButtonColor: "#147fc1",
        });

        return false;
      }

      // ==========================================
      // TOKEN DE VERIFICAÇÃO
      // ==========================================

      const tokenVerificacao =
        data.tokenVerificacao;

      console.log(
        "TOKEN DE VERIFICAÇÃO:",
        tokenVerificacao
      );

      if (!tokenVerificacao) {
        setEnviandoCodigo(false);

        await Swal.fire({
          width: "500px",
          padding: "0",
          background: "#0b1722",
          color: "#e8f1f7",

          icon: "error",

          title: "Erro na verificação",

          text:
            "O servidor não retornou o token de verificação.",

          confirmButtonText: "Entendi",

          confirmButtonColor: "#147fc1",
        });

        return false;
      }

      setEnviandoCodigo(false);

      // ==========================================
      // MODAL DE CONFIRMAÇÃO DO CÓDIGO
      // ==========================================

      const result = await Swal.fire({
        width: "430px",
        padding: "0",
        background: "#0b1722",
        color: "#e8f1f7",

        html: `
      <div style="
        padding: 28px 30px 24px;
        text-align:left;
      ">

        <div style="
          display:flex;
          align-items:center;
          gap:13px;
          margin-bottom:22px;
        ">

          <div style="
            width:42px;
            height:42px;
            border-radius:11px;
            display:flex;
            align-items:center;
            justify-content:center;
            background:rgba(56,189,248,.08);
            border:1px solid rgba(56,189,248,.20);
            color:#38bdf8;
            font-size:18px;
          ">
            <i class="bi bi-phone"></i>
          </div>

          <div>
            <div style="
              font-size:18px;
              font-weight:700;
              color:#f8fafc;
              line-height:1.2;
            ">
              Confirmar celular
            </div>

            <div style="
              margin-top:4px;
              font-size:12px;
              color:#64748b;
            ">
              Validação de segurança do cadastro
            </div>
          </div>

        </div>

        <div style="
          padding:13px 15px;
          border-radius:11px;
          background:#101d2a;
          border:1px solid rgba(148,163,184,.10);
          margin-bottom:18px;
        ">

          <div style="
            font-size:10px;
            font-weight:700;
            color:#64748b;
            text-transform:uppercase;
            letter-spacing:.7px;
            margin-bottom:5px;
          ">
            Código enviado para
          </div>

          <div style="
            font-size:14px;
            font-weight:600;
            color:#e2e8f0;
          ">
            +55 (${telefone.slice(0, 2)})
            ${telefone.slice(2, 7)}-${telefone.slice(7)}
          </div>

        </div>

        <div style="
          font-size:12px;
          color:#94a3b8;
          margin-bottom:8px;
        ">
          Digite o código de 6 dígitos recebido por SMS.
        </div>

        <input
          id="codigo-sms"
          type="text"
          inputmode="numeric"
          maxlength="6"
          autocomplete="one-time-code"
          placeholder="000000"
          style="
            width:100%;
            height:48px;
            box-sizing:border-box;
            margin:0;
            padding:0 14px;
            border-radius:10px;
            border:1px solid #26394a;
            background:#0f1a26;
            color:#f8fafc;
            font-size:20px;
            font-weight:600;
            letter-spacing:5px;
            text-align:center;
            outline:none;
          "
        />

        <div style="
          display:flex;
          align-items:center;
          gap:7px;
          margin-top:12px;
          font-size:11px;
          color:#64748b;
        ">
          <i class="bi bi-clock"></i>
          O código é válido por alguns minutos.
        </div>

      </div>
    `,

        showCancelButton: true,

        confirmButtonText: "Confirmar",

        cancelButtonText: "Cancelar",

        confirmButtonColor: "#147fc1",

        cancelButtonColor: "#1e293b",

        reverseButtons: true,

        focusConfirm: false,

        preConfirm: () => {
          const codigo = document
            .getElementById("codigo-sms")
            ?.value
            ?.replace(/\D/g, "");

          if (!codigo) {
            Swal.showValidationMessage(
              "Informe o código recebido por SMS."
            );

            return false;
          }

          if (codigo.length !== 6) {
            Swal.showValidationMessage(
              "O código deve possuir 6 dígitos."
            );

            return false;
          }

          return codigo;
        },

        customClass: {
          popup: "swal-usuario-sms",
          confirmButton: "swal-usuario-sms-confirm",
          cancelButton: "swal-usuario-sms-cancel",
        },
      });

      // ==========================================
      // CANCELou O MODAL
      // ==========================================

      if (!result.isConfirmed) {
        return false;
      }

      // ==========================================
      // PEGA CÓDIGO
      // ==========================================

      const codigo = result.value;

      if (!tokenVerificacao) {
        throw new Error(
          "Token de verificação não encontrado. Solicite um novo código."
        );
      }

      // ==========================================
      // CONFIRMA CÓDIGO
      // ==========================================

      const resposta = await api.post(
        "/usuario/confirmar-codigo-sms",
        {
          telefone,
          codigo,
          tokenVerificacao,
        }
      );

      if (!resposta.data?.sucesso) {
        throw new Error(
          resposta.data?.mensagem ||
          resposta.data?.message ||
          "Código inválido."
        );
      }

      // ==========================================
      // TELEFONE CONFIRMADO
      // ==========================================

      setTelefoneVerificado(true);

      await Swal.fire({
        width: "390px",
        background: "#0b1722",
        color: "#e8f1f7",

        icon: "success",

        iconColor: "#22c55e",

        title: "Celular confirmado",

        text: "O número foi validado com sucesso.",

        confirmButtonText: "Continuar",

        confirmButtonColor: "#1686bd",
      });

      return true;

    } catch (error) {

      // ==========================================
      // ERRO NA CONFIRMAÇÃO DO CÓDIGO
      // ==========================================

      setEnviandoCodigo(false);

      console.error(
        "Erro ao confirmar telefone:",
        error
      );

      Swal.fire({
        width: "500px",
        padding: "0",
        background: "#0b1722",
        color: "#e8f1f7",

        html: `
      <div style="
        padding:26px 28px;
        text-align:left;
      ">

        <div style="
          display:flex;
          align-items:center;
          gap:12px;
          margin-bottom:16px;
        ">

          <div style="
            width:40px;
            height:40px;
            border-radius:10px;
            display:flex;
            align-items:center;
            justify-content:center;
            color:#f87171;
            background:rgba(239,68,68,.07);
            border:1px solid rgba(239,68,68,.22);
          ">
            <i class="bi bi-exclamation-triangle"></i>
          </div>

          <div>
            <div style="
              font-size:17px;
              font-weight:700;
              color:#f8fafc;
            ">
              Não foi possível confirmar
            </div>

            <div style="
              margin-top:3px;
              font-size:12px;
              color:#64748b;
            ">
              Verifique o código e tente novamente.
            </div>
          </div>

        </div>

        <div style="
          padding:12px 14px;
          border-radius:10px;
          background:#101d2a;
          border:1px solid rgba(148,163,184,.10);
          color:#94a3b8;
          font-size:12px;
          line-height:1.5;
        ">
          ${error.response?.data?.mensagem ||
          error.response?.data?.message ||
          error.message ||
          "Erro ao validar o número."
          }
        </div>

      </div>
    `,

        confirmButtonText: "Entendi",

        confirmButtonColor: "#147fc1",

        customClass: {
          popup: "swal-usuario-sms",
          confirmButton: "swal-usuario-sms-confirm",
        },
      });

      return false;
    }
  };


  const verificarTelefone = async (telefone) => {

    const telefoneLimpo =
      telefone.replace(/\D/g, "");

    // Ainda não terminou de digitar
    if (telefoneLimpo.length !== 11) {

      setTelefoneExistente(false);

      return;

    }

    try {

      setVerificandoTelefone(true);

      const { data } = await api.post(
        "/usuario/verificar-telefone",
        {
          telefone: telefoneLimpo
        }
      );

      if (data.existe) {

        setTelefoneExistente(true);

        setTelefoneVerificado(false);

        return;

      }

      setTelefoneExistente(false);

    } catch (error) {

      console.error(
        "Erro ao verificar telefone:",
        error
      );

    } finally {

      setVerificandoTelefone(false);

    }

  };


  const enviarCodigoEmail = async (emailInformado) => {
  const email = emailInformado?.trim().toLowerCase();

  // ==========================================
  // VALIDA E-MAIL
  // ==========================================

  const emailValido =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/
      .test(email);

  if (!email || !emailValido) {
    await Swal.fire({
      html: `
        <div class="swal-email-invalido">

          <div class="swal-email-invalido-icon">
            <i class="bi bi-envelope-exclamation"></i>
          </div>

          <div class="swal-email-invalido-content">

            <div class="swal-email-invalido-title">
              E-mail inválido
            </div>

            <div class="swal-email-invalido-message">
              Insira um e-mail válido para continuar.
            </div>

          </div>

        </div>
      `,

      showConfirmButton: true,
      confirmButtonText: "Entendi",

      customClass: {
        popup: "swal-email-invalido-popup",
        confirmButton: "swal-email-invalido-confirm",
      },

      background: "#0d1b2a",
      color: "#eaf4fb",
      buttonsStyling: false,
    });

    return;
  }

  // ==========================================
  // ENVIA CÓDIGO
  // ==========================================

  try {
    const response = await api.post(
      "/usuarios/enviar-codigo-email",
      {
        email,
      }
    );

    // ==========================================
    // CÓDIGO FOI ENVIADO
    // ==========================================

    if (response.data?.message) {
      setCodigoEnviado(true);

      await abrirModalCodigoEmail(email);
    }

  } catch (error) {
    console.error("Erro ao enviar código:", error);

    // ==========================================
    // ERRO AO ENVIAR
    // ==========================================

    await Swal.fire({
         html: `
    <div class="swal-email-invalido">

      <div class="swal-email-invalido-icon">
        <i class="bi bi-envelope-exclamation"></i>
      </div>

      <div class="swal-email-invalido-content">

        <div class="swal-email-invalido-title">
          E-mail inválido
        </div>

        <div class="swal-email-invalido-message">
          Insira um e-mail válido para continuar.
        </div>

      </div>

    </div>
  `,

      showConfirmButton: true,
      confirmButtonText: "Entendi",

      customClass: {
        popup: "swal-email-invalido-popup",
        confirmButton: "swal-email-invalido-confirm",
      },

      background: "#0d1b2a",
      color: "#eaf4fb",
      buttonsStyling: false,
    });
  }
};

  const abrirModalCodigoEmail = async (email) => {
    const result = await Swal.fire({
      title: "Verificar e-mail",

      html: `
      <div class="modal-verificacao-email">

        <div class="modal-email-icon">
          ✉
        </div>

        <p class="modal-email-text">
          Enviamos um código de 6 dígitos para:
        </p>

        <strong class="modal-email-endereco">
          ${email}
        </strong>

        <div class="codigo-email-inputs">

          <input
            id="codigo-1"
            class="codigo-email-input"
            type="text"
            inputmode="numeric"
            maxlength="1"
            autocomplete="one-time-code"
          />

          <input
            id="codigo-2"
            class="codigo-email-input"
            type="text"
            inputmode="numeric"
            maxlength="1"
          />

          <input
            id="codigo-3"
            class="codigo-email-input"
            type="text"
            inputmode="numeric"
            maxlength="1"
          />

          <input
            id="codigo-4"
            class="codigo-email-input"
            type="text"
            inputmode="numeric"
            maxlength="1"
          />

          <input
            id="codigo-5"
            class="codigo-email-input"
            type="text"
            inputmode="numeric"
            maxlength="1"
          />

          <input
            id="codigo-6"
            class="codigo-email-input"
            type="text"
            inputmode="numeric"
            maxlength="1"
          />

        </div>

        <div class="modal-email-expira">
          O código é válido por <strong>15 minutos</strong>.
        </div>

      </div>
    `,

      background: "#0f172a",
      color: "#fff",

      showCancelButton: true,

      confirmButtonText: "Validar e-mail",
      cancelButtonText: "Cancelar",

      confirmButtonColor: "#0F73B2",
      cancelButtonColor: "#334155",

      allowOutsideClick: false,

      focusConfirm: false,

      customClass: {
        popup: "modal-verificacao-email-popup",
        confirmButton: "modal-email-confirmar",
        cancelButton: "modal-email-cancelar",
      },

      didOpen: () => {
        const inputs = document.querySelectorAll(
          ".codigo-email-input"
        );

        inputs.forEach((input, index) => {

          input.addEventListener("input", (event) => {

            // Somente números
            event.target.value =
              event.target.value.replace(/\D/g, "");

            if (
              event.target.value &&
              index < inputs.length - 1
            ) {
              inputs[index + 1].focus();
            }
          });

          input.addEventListener("keydown", (event) => {

            if (
              event.key === "Backspace" &&
              !input.value &&
              index > 0
            ) {
              inputs[index - 1].focus();
            }
          });

          input.addEventListener("paste", (event) => {

            event.preventDefault();

            const texto = (
              event.clipboardData ||
              window.clipboardData
            )
              .getData("text")
              .replace(/\D/g, "")
              .slice(0, 6);

            texto.split("").forEach((numero, i) => {
              if (inputs[i]) {
                inputs[i].value = numero;
              }
            });

            const ultimo =
              Math.min(texto.length, 6) - 1;

            if (ultimo >= 0) {
              inputs[ultimo].focus();
            }
          });
        });

        if (inputs[0]) {
          inputs[0].focus();
        }
      },

      preConfirm: async () => {

        const inputs = document.querySelectorAll(
          ".codigo-email-input"
        );

        const codigo = Array.from(inputs)
          .map((input) => input.value)
          .join("");

        if (codigo.length !== 6) {

          Swal.showValidationMessage(
            "Digite o código completo de 6 dígitos."
          );

          return false;
        }

        try {

          const response = await api.post(
            "/usuarios/verificar-codigo-email",
            {
              email,
              codigo,
            }
          );

          return response.data;

        } catch (error) {

          Swal.showValidationMessage(
            error.response?.data?.message ||
            "Código inválido ou expirado."
          );

          return false;
        }
      },
    });

    // ==========================================
    // CÓDIGO CONFIRMADO
    // ==========================================

    if (result.isConfirmed) {

      setEmailVerificado(true);
      setCodigoEnviado(false);

      Swal.fire({
        icon: "success",
        title: "E-mail verificado!",
        text: "O endereço de e-mail foi confirmado com sucesso.",
        background: "#0f172a",
        color: "#fff",
        confirmButtonColor: "#0F73B2",
      });
    }
  };



  return (

    <>

      <ToastContainer />



      <div className="usuario-cadastro">



        <div className="card-usuario">



          {/* =====================================================

            HEADER

        ====================================================== */}



          <div className="usuario-header">



            <div className="usuario-header-left">



              <div className="usuario-header-icon">

                <i className="bi bi-person-plus"></i>

              </div>



              <div>



                <h5 className="usuario-title">

                  Cadastro de usuário

                </h5>



                <span className="usuario-subtitle">

                  Configure o acesso e as permissões do usuário

                </span>



              </div>



            </div>





            <button

              type="button"

              className="usuario-close"

              onClick={() => navigate(-1)}

              title="Fechar"

            >

              <i className="bi bi-x-lg"></i>

            </button>



          </div>





          {/* =====================================================

            BODY

        ====================================================== */}



          <div className="cadastro-usuario">



            <form

              autoComplete="off"

              className="usuario-form"

            >



              {/* CAMPOS FANTASMA PARA EVITAR AUTOFILL */}



              <input

                type="text"

                name="fakeuser"

                autoComplete="username"

                style={{ display: "none" }}

              />



              <input

                type="password"

                name="fakepass"

                autoComplete="current-password"

                style={{ display: "none" }}

              />





              {/* =================================================

                INFORMAÇÕES

            ================================================== */}



              <div className="usuario-section">



                <div className="usuario-section-header">



                  <span className="usuario-section-line"></span>



                  <div>



                    <span className="usuario-section-title">

                      Informações

                    </span>



                    <span className="usuario-section-description">

                      Dados básicos de acesso

                    </span>



                  </div>



                </div>





                {/* =================================================

                  NOME

              ================================================== */}



                <div className="usuario-field usuario-field-full">



                  <label className="usuario-label">

                    Nome completo <span className="campo-obrigatorio">*</span>

                  </label>



                  <input

                    placeholder="Nome Completo"

                    maxLength={65}

                    type="text"

                    name="nome"

                    autoComplete="off"

                    className={`usuario-input ${errosCampos?.nome ? "usuario-input-error" : ""
                      }`}
                    onChange={(e) => handleChange(e)}
                  />

                  {errosCampos?.nome && (
                    <div className="usuario-error">
                      {errosCampos.nome}
                    </div>
                  )}



                  <div className="usuario-field-footer">

                    <span></span>



                    <small>

                      {(values.nome || "").length}/65

                    </small>

                  </div>



                </div>





                {/* =================================================

                  USUÁRIO

              ================================================== */}



                <div className="usuario-grid-2">



                  <div className="usuario-field">



                    <label className="usuario-label">

                      Nome de usuário <span className="campo-obrigatorio">*</span>

                    </label>



                    <input

                      maxLength={30}

                      type="text"

                      name="user"

                      autoComplete="off"

                      className={`usuario-input ${userError || errosCampos?.user
                        ? "usuario-input-error"
                        : ""
                        }`}

                      onChange={(e) => handleChange(e)}

                    />



                    {(userError || errosCampos?.user) && (
                      <div className="usuario-error">
                        {userError || errosCampos.user}
                      </div>
                    )}



                    <div className="usuario-field-footer">

                      <span></span>



                      <small>

                        {(values.user || "").length}/30

                      </small>

                    </div>



                  </div>





                  {/* =================================================

                    EMAIL

                ================================================== */}


                  <div className="usuario-field">

                    <label className="usuario-label">
                      E-mail
                    </label>

                    <div className="usuario-email-wrapper">

                      <input
                        type="email"
                        name="email"
                        autoComplete="off"
                        value={email}
                        className={`usuario-input ${emailError || errosCampos?.email
                          ? "usuario-input-error"
                          : ""
                          } ${emailDisponivel
                            ? "usuario-input-success"
                            : ""
                          }`}
                        onChange={(e) => {
                          const valor = e.target.value;

                          setEmail(valor);

                          setValues((prev) => ({
                            ...prev,
                            email: valor,
                          }));

                          if (emailVerificado) {
                            setEmailVerificado(false);
                          }

                          setCodigoEnviado(false);
                        }}
                        placeholder="ex: email@empresa.com"
                      />

                      {verificandoEmail && email && (
                        <span className="email-status-loading">
                          Verificando...
                        </span>
                      )}

                    </div>

                    {/* E-MAIL JÁ EXISTE */}
                    {emailError && (
                      <div className="usuario-error">
                        {emailError}
                      </div>
                    )}

                    {/* E-MAIL DISPONÍVEL */}
                    {!emailError && emailDisponivel && !emailVerificado && (
                      <div className="email-validacao-area">

                        <div className="email-disponivel">
                          ✓ E-mail disponível
                        </div>

                        <button
                          type="button"
                          className="btn-validar-email"
                          onClick={() => enviarCodigoEmail(email)}
                          disabled={verificandoEmail}
                        >
                          ✉ Validar e-mail
                        </button>

                      </div>
                    )}

                    {/* E-MAIL JÁ VERIFICADO */}
                    {emailVerificado && (
                      <div className="email-verificado">
                        ✓ E-mail verificado
                      </div>
                    )}

                  </div>





                  {/* =================================================

                    TELEFONE

                ================================================== */}



                  <div className="usuario-field">



                    <label className="usuario-label usuario-label-telefone">



                      Celular



                      <span className="usuario-label-optional">

                        opcional

                      </span>



                    </label>





                    {/* =================================================

                      CHECKBOX

                  ================================================== */}



                    <label className="usuario-phone-check">



                      <input

                        type="checkbox"

                        checked={usarTelefone}

                        onChange={(e) => {



                          const marcado =

                            e.target.checked;



                          setUsarTelefone(marcado);



                          // Se desmarcar, limpa telefone

                          if (!marcado) {



                            handleChange({

                              target: {

                                name: "telefone",

                                value: "",

                              },

                            });



                            setTelefoneVerificado(false);



                            setTelefoneExistente(false);



                          }



                        }}

                      />



                      <span className="usuario-phone-check-box">



                        <i className="bi bi-check"></i>



                      </span>



                      <span className="usuario-phone-check-text">



                        Desejo cadastrar um número de celular



                      </span>



                    </label>





                    {/* =================================================

                      CAMPO DE TELEFONE

                  ================================================== */}



                    <div

                      className={`usuario-phone ${!usarTelefone

                        ? "usuario-phone-disabled"

                        : ""

                        } ${telefoneExistente

                          ? "usuario-phone-error-border"

                          : ""

                        }`}

                    >



                      <div className="usuario-phone-prefix">

                        +55

                      </div>



                      <input

                        type="tel"

                        name="telefone"

                        value={values.telefone || ""}

                        maxLength={15}

                        inputMode="numeric"

                        autoComplete="tel"

                        disabled={!usarTelefone}

                        className="usuario-input usuario-phone-input"

                        placeholder="(11) 99999-9999"

                        onChange={(e) => {



                          let valor =

                            e.target.value

                              .replace(/\D/g, "")

                              .slice(0, 11);



                          let valorFormatado =

                            valor;



                          if (valor.length <= 2) {



                            valorFormatado =

                              valor;



                          } else if (

                            valor.length <= 7

                          ) {



                            valorFormatado =

                              `(${valor.slice(0, 2)}) ` +

                              `${valor.slice(2)}`;



                          } else {



                            valorFormatado =

                              `(${valor.slice(0, 2)}) ` +

                              `${valor.slice(2, 7)}-` +

                              `${valor.slice(7)}`;



                          }



                          handleChange({

                            target: {

                              name: "telefone",

                              value: valorFormatado,

                            },

                          });





                          // =====================================

                          // VERIFICA BANCO

                          // =====================================



                          if (

                            valor.length === 11

                          ) {



                            verificarTelefone(

                              valor

                            );



                          } else {



                            setTelefoneExistente(

                              false

                            );



                            setTelefoneVerificado(

                              false

                            );



                          }



                        }}

                      />



                    </div>





                    {/* =================================================

                      VERIFICANDO TELEFONE

                  ================================================== */}



                    {verificandoTelefone && (



                      <div className="usuario-phone-checking">



                        <span className="telefone-spinner"></span>



                        <span>

                          Verificando número...

                        </span>



                      </div>



                    )}





                    {/* =================================================

                      TELEFONE JÁ EXISTE

                  ================================================== */}



                    {telefoneExistente && (



                      <div className="usuario-phone-error">



                        <i className="bi bi-exclamation-circle"></i>



                        <span>

                          Este número de celular já está cadastrado.

                        </span>



                      </div>



                    )}





                    {/* =================================================

                      TELEFONE NÃO INFORMADO

                  ================================================== */}



                    {!usarTelefone && (



                      <div className="usuario-phone-info">



                        <i className="bi bi-info-circle"></i>



                        <span>

                          O celular é opcional.

                        </span>



                      </div>



                    )}





                    {/* =================================================

                      TELEFONE ATIVADO

                  ================================================== */}



                    {usarTelefone &&

                      !telefoneExistente &&

                      !telefoneVerificado &&

                      values.telefone &&

                      !verificandoTelefone && (



                        <div className="usuario-phone-info">



                          <i className="bi bi-shield-check"></i>



                          <span>

                            Informe o número com DDD.

                            Será enviado um código por SMS

                            para confirmar o celular.

                          </span>



                        </div>



                      )}





                    {/* =================================================

                      BOTÃO CONFIRMAR SMS

                  ================================================== */}


                    {usarTelefone &&
                      values.telefone &&
                      !telefoneExistente &&
                      !telefoneVerificado &&
                      !verificandoTelefone && (
                        <button
                          type="button"
                          className="btn-confirmar-telefone"
                          onClick={confirmarTelefone}
                          disabled={enviandoCodigo}
                        >
                          {enviandoCodigo ? (
                            <>
                              <span className="telefone-spinner"></span>
                              Enviando código...
                            </>
                          ) : (
                            <>
                              <i className="bi bi-shield-check"></i>
                              Confirmar código SMS
                            </>
                          )}
                        </button>
                      )}




                    {/* =================================================

                      TELEFONE CONFIRMADO

                  ================================================== */}



                    {telefoneVerificado && (



                      <div className="telefone-verificado">



                        <i className="bi bi-check-circle-fill"></i>



                        <span>

                          Número confirmado

                        </span>



                      </div>



                    )}



                  </div>



                </div>





                {/* =================================================

                  SENHAS

              ================================================== */}



                <div className="usuario-grid-2">



                  {/* =================================================

                    SENHA

                ================================================== */}



                  <div className="usuario-field">



                    <label className="usuario-label">

                      Senha <span className="campo-obrigatorio">*</span>

                    </label>



                    <div className="usuario-password">



                      <input

                        type={

                          mostrarSenha

                            ? "text"

                            : "password"

                        }

                        name="senha"

                        autoComplete="new-password"

                        className={`usuario-input ${senhaError || errosCampos?.senha
                          ? "usuario-input-error"
                          : ""
                          }`}

                        value={senha}

                        onChange={(e) =>

                          setSenha(e.target.value)

                        }

                      />



                      <button

                        type="button"

                        className="usuario-password-toggle"

                        onClick={() =>

                          setMostrarSenha(

                            (prev) => !prev

                          )

                        }

                        tabIndex="-1"

                      >



                        <i

                          className={

                            mostrarSenha

                              ? "bi bi-eye-slash"

                              : "bi bi-eye"

                          }

                        ></i>



                      </button>



                    </div>



                  </div>





                  {/* =================================================

                    CONFIRMAR SENHA

                ================================================== */}



                  <div className="usuario-field">



                    <label className="usuario-label">

                      Confirmar senha <span className="campo-obrigatorio">*</span>

                    </label>



                    <div className="usuario-password">



                      <input

                        type={

                          mostrarConfirmar

                            ? "text"

                            : "password"

                        }

                        autoComplete="new-password"

                        className={`usuario-input ${senhaError || errosCampos?.confirmarSenha
                          ? "usuario-input-error"
                          : ""
                          }`}

                        value={confirmarSenha}

                        onChange={(e) =>

                          setConfirmarSenha(

                            e.target.value

                          )

                        }

                      />



                      <button

                        type="button"

                        className="usuario-password-toggle"

                        onClick={() =>

                          setMostrarConfirmar(

                            (prev) => !prev

                          )

                        }

                        tabIndex="-1"

                      >



                        <i

                          className={

                            mostrarConfirmar

                              ? "bi bi-eye-slash"

                              : "bi bi-eye"

                          }

                        ></i>



                      </button>



                    </div>



                    {(senhaError || errosCampos?.senha || errosCampos?.confirmarSenha) && (
                      <div className="usuario-error">
                        {senhaError ||
                          errosCampos?.confirmarSenha ||
                          errosCampos?.senha}
                      </div>
                    )}



                  </div>



                </div>





                {/* =================================================

                  TIPO

              ================================================== */}



                <div className="usuario-field usuario-field-full">



                  <label className="usuario-label">

                    Tipo de permissão

                  </label>



                  <Select

                    className="select-tipopermisaoUsuario"

                    options={opcoesTipo}

                    placeholder="Selecione uma opção"

                    value={opcoesTipo.find(

                      (option) =>

                        option.value ===

                        values.tipo

                    )}

                    onChange={handleTipoChange}

                    isClearable

                  />



                </div>



              </div>





              {/* =================================================

                VEÍCULOS

            ================================================== */}



              {tipoPermissao !== "a" && (



                <>



                  <div className="usuario-section">



                    <div className="usuario-section-header">



                      <span className="usuario-section-line"></span>



                      <div>



                        <span className="usuario-section-title">

                          Veículos

                        </span>



                        <span className="usuario-section-description">

                          Defina quais veículos estarão disponíveis

                        </span>



                      </div>



                    </div>





                    {/* =================================================

                      CONTROLES

                  ================================================== */}



                    <div className="usuario-selection-toolbar">



                      <div className="usuario-field">



                        <label className="usuario-label">

                          Buscar veículo

                        </label>



                        <div className="usuario-search">



                          <i className="bi bi-search"></i>



                          <input

                            type="text"

                            placeholder="Placa ou descrição..."

                            value={search}

                            onChange={(e) =>

                              setSearch(

                                e.target.value

                              )

                            }

                          />



                        </div>



                      </div>





                      <label className="usuario-check">



                        <input

                          type="checkbox"

                          checked={selecionarTodos}

                          onChange={(e) =>

                            handleAll(

                              e.target.checked

                            )

                          }

                        />



                        <span className="usuario-check-box">



                          <i className="bi bi-check"></i>



                        </span>



                        <span>

                          Selecionar todos

                        </span>



                      </label>



                    </div>





                    {/* =================================================

                      LISTAS

                  ================================================== */}



                    <div className="usuario-transfer">





                      {/* =================================================

                        DISPONÍVEIS

                    ================================================== */}



                      <div className="usuario-list-box">



                        <div className="usuario-list-header">



                          <div>



                            <span className="usuario-list-title">

                              Disponíveis

                            </span>



                            <span className="usuario-list-count">

                              {filterPlaca.length}

                            </span>



                          </div>



                          <span className="usuario-list-label">

                            PLACA / DESCRIÇÃO

                          </span>



                        </div>





                        <div className="lista-veiculos">



                          {filterPlaca.map((v) => (



                            <div

                              key={v.placa}

                              className="item-veiculo"

                              onClick={() =>

                                moverParaSelecionados(v)

                              }

                            >



                              <div className="usuario-item-main">



                                <span className="usuario-item-status"></span>



                                <div>



                                  <div className="placa">

                                    {v.placa}

                                  </div>



                                  <div className="descricao">

                                    {v.nome}

                                  </div>



                                </div>



                              </div>



                              <i className="bi bi-chevron-right usuario-item-arrow"></i>



                            </div>



                          ))}





                          {filterPlaca.length === 0 && (



                            <div className="usuario-list-empty">



                              <i className="bi bi-inbox"></i>



                              <span>

                                Nenhum veículo encontrado

                              </span>



                            </div>



                          )}



                        </div>



                      </div>





                      {/* =================================================

                        SETA

                    ================================================== */}



                      <div className="usuario-transfer-arrow">



                        <i className="bi bi-arrow-right"></i>



                      </div>





                      {/* =================================================

                        SELECIONADOS

                    ================================================== */}



                      <div className="usuario-list-box">



                        <div className="usuario-list-header">



                          <div>



                            <span className="usuario-list-title">

                              Selecionados

                            </span>



                            <span className="usuario-list-count active">

                              {veiculosSelecionados.length}

                            </span>



                          </div>



                          <span className="usuario-list-label">

                            VINCULADOS

                          </span>



                        </div>





                        <div className="lista-veiculos selecionados">



                          {veiculosSelecionados.map((v) => (



                            <div

                              key={v.placa}

                              className="item-veiculo usuario-item-selected"

                              onClick={() =>

                                moverParaDisponiveis(v)

                              }

                            >



                              <div className="usuario-item-main">



                                <span className="usuario-item-status selected"></span>



                                <div>



                                  <div className="placa">

                                    {v.placa}

                                  </div>



                                  <div className="descricao">

                                    {v.nome}

                                  </div>



                                </div>



                              </div>



                              <i className="bi bi-x usuario-item-remove"></i>



                            </div>



                          ))}





                          {veiculosSelecionados.length === 0 && (



                            <div className="usuario-list-empty">



                              <i className="bi bi-link-45deg"></i>



                              <span>

                                Nenhum veículo selecionado

                              </span>



                            </div>



                          )}



                        </div>



                      </div>



                    </div>



                  </div>





                  {/* =================================================

                    GRUPOS

                ================================================== */}



                  <div className="usuario-section">



                    <div className="usuario-section-header">



                      <span className="usuario-section-line"></span>



                      <div>



                        <span className="usuario-section-title">

                          Grupos

                        </span>



                        <span className="usuario-section-description">

                          Defina os grupos vinculados ao usuário

                        </span>



                      </div>



                    </div>





                    {/* =================================================

                      CONTROLES

                  ================================================== */}



                    <div className="usuario-selection-toolbar">



                      <div className="usuario-field">



                        <label className="usuario-label">

                          Buscar grupo

                        </label>



                        <div className="usuario-search">



                          <i className="bi bi-search"></i>



                          <input

                            type="text"

                            placeholder="Nome do grupo..."

                            value={searchGrupos}

                            onChange={(e) =>

                              setSearchGrupos(

                                e.target.value

                              )

                            }

                          />



                        </div>



                      </div>





                      <label className="usuario-check">



                        <input

                          type="checkbox"

                          onChange={(e) =>

                            handleAllGrupos(

                              e.target.checked

                            )

                          }

                        />



                        <span className="usuario-check-box">



                          <i className="bi bi-check"></i>



                        </span>



                        <span>

                          Selecionar todos

                        </span>



                      </label>



                    </div>





                    {/* =================================================

                      LISTAS

                  ================================================== */}



                    <div className="usuario-transfer">





                      {/* =================================================

                        DISPONÍVEIS

                    ================================================== */}



                      <div className="usuario-list-box">



                        <div className="usuario-list-header">



                          <div>



                            <span className="usuario-list-title">

                              Disponíveis

                            </span>



                            <span className="usuario-list-count">

                              {filterGrupos.length}

                            </span>



                          </div>



                          <span className="usuario-list-label">

                            GRUPOS

                          </span>



                        </div>





                        <div className="lista-veiculos">



                          {filterGrupos.map((grupo) => (



                            <div

                              key={grupo.id}

                              className="item-veiculo"

                              onClick={() =>

                                handleSelecionadasGrupos(

                                  grupo

                                )

                              }

                            >



                              <div className="usuario-item-main">



                                <span className="usuario-item-status"></span>



                                <div>



                                  <div className="placa">

                                    {grupo.nome}

                                  </div>



                                </div>



                              </div>



                              <i className="bi bi-chevron-right usuario-item-arrow"></i>



                            </div>



                          ))}





                          {filterGrupos.length === 0 && (



                            <div className="usuario-list-empty">



                              <i className="bi bi-inbox"></i>



                              <span>

                                Nenhum grupo encontrado

                              </span>



                            </div>



                          )}



                        </div>



                      </div>





                      {/* =================================================

                        SETA

                    ================================================== */}



                      <div className="usuario-transfer-arrow">



                        <i className="bi bi-arrow-right"></i>



                      </div>





                      {/* =================================================

                        SELECIONADOS

                    ================================================== */}



                      <div className="usuario-list-box">



                        <div className="usuario-list-header">



                          <div>



                            <span className="usuario-list-title">

                              Selecionados

                            </span>



                            <span className="usuario-list-count active">

                              {gruposSelecionadas.length}

                            </span>



                          </div>



                          <span className="usuario-list-label">

                            VINCULADOS

                          </span>



                        </div>





                        <div className="lista-veiculos selecionados">



                          {gruposSelecionadas.map((grupo) => (



                            <div

                              key={grupo.id}

                              className="item-veiculo usuario-item-selected"

                              onClick={() =>

                                handlePredefinidasGrupos(

                                  grupo

                                )

                              }

                            >



                              <div className="usuario-item-main">



                                <span className="usuario-item-status selected"></span>



                                <div>



                                  <div className="placa">

                                    {grupo.nome}

                                  </div>



                                </div>



                              </div>



                              <i className="bi bi-x usuario-item-remove"></i>



                            </div>



                          ))}





                          {gruposSelecionadas.length === 0 && (



                            <div className="usuario-list-empty">



                              <i className="bi bi-link-45deg"></i>



                              <span>

                                Nenhum grupo selecionado

                              </span>



                            </div>



                          )}



                        </div>



                      </div>



                    </div>



                  </div>



                </>



              )}





              {/* =================================================

                OBSERVAÇÃO

            ================================================== */}



              <div className="usuario-section usuario-section-observacao">



                <div className="usuario-section-header">



                  <span className="usuario-section-line"></span>



                  <div>



                    <span className="usuario-section-title">

                      Observação

                    </span>



                    <span className="usuario-section-description">

                      Informações adicionais

                    </span>



                  </div>



                </div>





                <div className="usuario-field">



                  <textarea

                    name="obs"

                    className="usuario-textarea"

                    placeholder="Digite uma observação sobre o usuário..."

                    maxLength={500}

                    autoComplete="off"

                    value={values.obs || ""}

                    onChange={handleChange}

                  />



                  <div className="usuario-textarea-footer">



                    <span>

                      Informações adicionais sobre o usuário

                    </span>



                    <span>

                      {values.obs?.length || 0}/500

                    </span>



                  </div>



                </div>



              </div>



            </form>





            {/* =====================================================

              FOOTER

          ====================================================== */}



            <div className="usuario-footer">



              <button

                type="button"

                onClick={() => navigate(-1)}

                className="btn-cancelar"

              >



                <i className="bi bi-x-lg"></i>



                Cancelar



              </button>





              <button

                type="button"

                onClick={handleSubmit}

                className="btn-cadastrar"

                disabled={

                  usarTelefone &&

                  (

                    !telefoneVerificado ||

                    telefoneExistente ||

                    verificandoTelefone

                  )

                }

              >



                <i className="bi bi-check2"></i>



                Cadastrar



              </button>



            </div>



          </div>



        </div>



      </div>

    </>

  );
}
export default UsuarioCad;
